<template>
  <div class="yxtbiz-enroll-detail">
    <yxt-page-header :title="$t('pc_biz_enroll_lbl_apply' /* 报名 */)" @back="backRouter"></yxt-page-header>
    <div v-loading="loading" class="yxtbiz-enroll-detail__content">
      <yxt-row v-if="record === null"
              class="bg-white"
              type="flex"
              align="center"
              justify="middle">
        <yxt-empty v-if="!loading" />
      </yxt-row>
      <template v-else>
        <div class="yxtbiz-enroll-detail__info">
          <!-- 用户信息 -->
          <div class="yxtbiz-enroll-detail__info-user bg-white">
            <yxt-avatar
              class="yxtbiz-enroll-detail__info-user-left"
              size="70px"
              :imgUrl="record.user.imgUrl"
              :username='record.user.fullname'
            ></yxt-avatar>
            <div class="yxtbiz-enroll-detail__info-user-right ml16 text-26">
              <yxt-tooltip effect="dark" placement="top" open-filter>
                <div slot="content">
                  <yxtbiz-user-name :name="record.user.fullname" />
                </div>
                <div class="font-size-18 font-bolder nowrap ellipsis lh26">
                  <yxtbiz-user-name :name="record.user.fullname || '--'"/>
                </div>
              </yxt-tooltip>
              <div class="mt8 font-size-14 text-8c nowrap ellipsis lh20">
                <yxtbiz-user-name :name="record.user.username"/>
              </div>
              <div class="yxtbiz-enroll-detail__info-user-pd d-flex mt8 font-size-14">
                <span>{{ $t('pc_biz_enroll_col_position' /* 岗位 */) + $t('pc_biz_enroll_lbl_colon' /* ： */) }}</span>
                <yxt-tooltip v-if="record.user.positionList"
                            effect="dark"
                            :content="record.user.positionList"
                            placement="top"
                            open-filter>
                  <div class="mw-35 nowrap ellipsis">{{ record.user.positionList }}</div>
                </yxt-tooltip>
                <span v-else>--</span>
                <yxt-divider direction="vertical"></yxt-divider>
                <span>{{ $t('pc_biz_enroll_lbl_dept' /* 部门 */) + $t('pc_biz_enroll_lbl_colon' /* ： */) }}</span>
                <div v-if="record.user.deptName" class="enroll-audit-info__department">
                  <yxt-tooltip effect="dark" placement="top" open-filter>
                    <div slot="content">
                      <yxtbiz-user-name :name="record.user.deptName" />
                    </div>
                    <span class="mw-35 nowrap ellipsis">
                      <yxtbiz-dept-name :name="record.user.deptName" />
                    </span>
                  </yxt-tooltip>
                </div>
                <span v-else>--</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white p24 text-26 font-size-14 mt12">
          <!-- 项目信息 -->
          <div class="yxtbiz-enroll-detail__project pb16">
            <div class="d-flex align-center font-size-16 font-bolder lh24">
              <span class="yxtbiz-enroll-detail__title-identify"></span>
              <span class="ml12">{{ $t('pc_biz_enroll_lbl_project' /* 报名项目 */)}}</span>
            </div>
            <yxt-row class="mt24">
              <yxt-col :span="24" class="d-flex align-center ph16 mb16">
                <div class="flex-shrink-0 text-8c">{{ $t('pc_biz_enroll_lbl_projectname' /* 项目名称 */) + $t('pc_biz_enroll_lbl_colon' /* ： */) }}</div>
                <yxt-tooltip effect="dark"
                            :content="record.projectName"
                            placement="top"
                            open-filter>
                  <div class="flex-1 nowrap ellipsis">{{ record.projectName }}</div>
                </yxt-tooltip>
              </yxt-col>
            </yxt-row>
          </div>
          <!-- 审核意见 -->
          <div class="yxtbiz-enroll-detail__opinion pb16">
            <div class="d-flex align-center font-size-16 font-bolder lh24">
              <span class="yxtbiz-enroll-detail__title-identify"></span>
              <span class="ml12">{{$t('pc_biz_enroll_lbl_auditopinion' /* 审核意见 */)}}</span>
            </div>
            <!-- 后台审核 -->
            <template v-if="record.checkStatus === 0">
              <yxt-radio-group v-model="auditResult" class="mt20">
                <yxt-radio :label="1">{{ $t('pc_biz_enroll_lbl_formalstudent'/*正式学员*/) }}</yxt-radio>
                <yxt-radio :label="2">{{ $t('pc_biz_enroll_lbl_auditrefuse'/*审核不通过*/) }}</yxt-radio>
              </yxt-radio-group>
              <yxt-input v-model="checkOpinion"
                        type="textarea"
                        :rows="5"
                        class="mt16"
                        maxlength="200"
                        show-word-limit></yxt-input>
              <div class="pt32">
                <yxt-button type="primary"
                            :loading="checkLoading"
                            @click="manageAudit">
                  {{ $t('pc_biz_enroll_confirm_btn' /*确定*/) }}
                </yxt-button>
              </div>
            </template>
            <!-- 审核结果 -->
            <template v-else>
              <yxt-row class="mt24">
                <yxt-col :span="24" class="d-flex align-center ph16 mb16">
                  <div class="flex-shrink-0 text-8c">{{$t('pc_biz_enroll_lbl_auditstatus' /* 审核状态 */) + $t('pc_biz_enroll_lbl_colon' /* ： */) }}</div>
                  <div v-if="record.checkStatus === 1" class="flex-1">{{ $t('pc_biz_enroll_tip_auditsuccess' /* 审核成功 */) }} ({{record.userType === 2 ? $t('pc_biz_enroll_lbl_formalstudent' /* 正式学员 */) : $t('pc_biz_enroll_lbl_substitutestudent' /* 替补学员 */)}})</div>
                  <div v-else class="flex-1">{{ statusText }}</div>
                </yxt-col>
              </yxt-row>
              <yxt-row v-if="record.checkUserName">
                <yxt-col :span="24" class="d-flex align-center ph16 mb16">
                  <div class="flex-shrink-0 text-8c">{{$t('pc_biz_enroll_lbl_auditor' /* 审核人 */) + $t('pc_biz_enroll_lbl_colon' /* ： */) }}</div>
                  <div class="flex-1"><yxtbiz-user-name :name="record.checkUserName" /></div>
                </yxt-col>
              </yxt-row>
              <yxt-row v-if="record.checkTime">
                <yxt-col :span="24" class="d-flex align-center ph16 mb16">
                  <div class="flex-shrink-0 text-8c">{{$t('pc_biz_enroll_lbl_audittime' /* 审核时间 */) + $t('pc_biz_enroll_lbl_colon' /* ： */) }}</div>
                  <div class="flex-1">{{ record.checkTime| date('yyyy-MM-dd hh:mm') }}</div>
                </yxt-col>
              </yxt-row>
              <yxt-row v-if="record.checkOpinion">
                <yxt-col :span="24" class="d-flex align-center ph16 mb16">
                  <div class="flex-shrink-0 text-8c">{{$t('pc_biz_enroll_lbl_auditopinion' /* 审核意见 */) + $t('pc_biz_enroll_lbl_colon' /* ： */) }}</div>
                  <div class="flex-1">{{ record.checkOpinion}}</div>
                </yxt-col>
              </yxt-row>
              <slot name="next"></slot>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  PageHeader,
  Row,
  Col,
  Empty,
  Divider,
  Avatar,
  Tooltip } from 'yxt-pc';
import YxtBizUserName from 'yxt-biz-pc/packages/user-name';
import YxtBizDeptName from 'yxt-biz-pc/packages/dept-name';
import {
  getRecord,
  checkRecords } from './service';
export default {
  name: 'YxtbizEnrollDetail',
  components: {
    YxtPageHeader: PageHeader,
    YxtRow: Row,
    YxtCol: Col,
    YxtEmpty: Empty,
    YxtDivider: Divider,
    YxtAvatar: Avatar,
    YxtTooltip: Tooltip,
    YxtBizUserName,
    YxtBizDeptName
  },
  props: {
    recordId: String, // 报名记录id
    projectId: String // 报名id
  },
  data() {
    return {
      loading: false,
      record: null,
      auditResult: 1,
      checkOpinion: '',
      checkLoading: false
    };
  },
  watch: {
    recordId: {
      immediate: true, // immediate选项可以开启首次赋值监听
      handler(value) {
        if (value) {
          this.getData();
        } else {
          this.record = null;
        }
      }
    }
  },
  computed: {
    statusText() {
      // 审核状态,0：待审核，1：通过，2：不通过，3:放弃资格，4：取消资格
      switch (this.record.checkStatus) {
        case 0:
          return this.$t('pc_biz_enroll_lbl_toaudit' /* 待审核 */);
        case 1:
          return this.$t('pc_biz_enroll_tip_auditsuccess' /* 审核成功 */);
        case 2:
          return this.$t('pc_biz_enroll_lbl_auditrefuse' /* 审核不通过 */);
        case 3:
          return this.$t('pc_biz_enroll_lbl_giveup' /* 放弃资格 */);
        case 4:
          return this.$t('pc_biz_enroll_lbl_disqualification' /* 取消资格 */);
        default:
          return '-';
      }
    }
  },
  filters: {
    date(date, fmt = 'yyyy-MM-dd hh:mm:ss', emptyChar = '--') {
      if (!date) return emptyChar;
      if (typeof date === 'string') {
        date = new Date(date.replace(/-/g, '/'));
      } else if (typeof date === 'number') {
        date = new Date(date);
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)); }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
      }
      return fmt;
    }
  },
  methods: {
    // 页面返回
    backRouter() {
      this.$emit('back');
    },
    // 获取详情数据
    getData() {
      this.loading = true;
      getRecord(this.recordId).then(res => {
        this.record = res;
      }).catch(() => {
        this.record = null;
      }).finally(() => {
        this.loading = false;
      });
    },
    manageAudit() {
      this.checkLoading = true;
      let params = {
        userId: this.record.user.id,
        projectId: this.projectId,
        checkStatus: this.auditResult,
        checkOpinion: this.checkOpinion
      };
      if (Number(this.auditResult) === 1) {
        params.userType = 2; //  1为替补学员 2为正式学员
      }
      checkRecords(params).then(res => {
        this.$message.success('操作成功');
        this.$emit('checkSuccess');
      }).catch(error => {
        this.$message.error(error.error.message);
      }).finally(() => {
        this.checkLoading = false;
      });
    }
  }
};
</script>
